import { useEffect, useRef } from "react";

export default function WellnessRing({ className = "" }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let w, h, cx, cy;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    const particles = Array.from({ length: 42 }, (_, i) => ({
      angle: (Math.PI * 2 * i) / 42,
      radius: 0.62 + Math.random() * 0.36,
      speed: 0.0018 + Math.random() * 0.0035,
      size: 1.2 + Math.random() * 2.4,
      teal: Math.random() > 0.72,
      wobble: Math.random() * Math.PI * 2,
    }));

    const resize = () => {
      const rect = canvas.parentElement.getBoundingClientRect();
      w = rect.width;
      h = rect.height;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cx = w / 2;
      cy = h / 2;
    };

    let t = 0;
    const draw = () => {
      t += 1;
      ctx.clearRect(0, 0, w, h);
      const R = Math.min(w, h) * 0.34;

      const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, R * 1.4);
      grad.addColorStop(0, "rgba(132,204,22,0.16)");
      grad.addColorStop(0.55, "rgba(132,204,22,0.05)");
      grad.addColorStop(1, "rgba(132,204,22,0)");
      ctx.fillStyle = grad;
      ctx.beginPath();
      ctx.arc(cx, cy, R * 1.4, 0, Math.PI * 2);
      ctx.fill();

      ctx.strokeStyle = "rgba(15,118,110,0.18)";
      ctx.lineWidth = 1;
      [0.62, 0.82, 1.0].forEach((r) => {
        ctx.beginPath();
        ctx.arc(cx, cy, R * r, 0, Math.PI * 2);
        ctx.stroke();
      });

      particles.forEach((p) => {
        p.angle += p.speed;
        const wob = Math.sin(t * 0.02 + p.wobble) * 4;
        const x = cx + Math.cos(p.angle) * (R * p.radius + wob);
        const y = cy + Math.sin(p.angle) * (R * p.radius * 0.94 + wob);
        ctx.beginPath();
        ctx.fillStyle = p.teal ? "rgba(15,118,110,0.65)" : "rgba(132,204,22,0.75)";
        ctx.arc(x, y, p.size, 0, Math.PI * 2);
        ctx.fill();
      });

      raf = requestAnimationFrame(draw);
    };

    resize();
    draw();
    const ro = new ResizeObserver(resize);
    ro.observe(canvas.parentElement);
    return () => {
      cancelAnimationFrame(raf);
      ro.disconnect();
    };
  }, []);

  return <canvas ref={canvasRef} className={className} aria-hidden="true" />;
}
